import { useContext } from "react";
import { userContext } from "./ContextProvider";
import { Navigate } from "react-router-dom";
import * as APITypes from "~/API";
import { ROUTES } from "~/utils";

export const ProtectedRoute = ({
  children,
  roles,
}: {
  children: React.ReactNode;
  roles: APITypes.TenantStatusType[];
}) => {
  const {
    status,
    authenticated,
    isDoneWithBackground,
  }: {
    status: APITypes.TenantStatusType;
    authenticated: boolean;
    isDoneWithBackground: boolean;
  } = useContext(userContext);

  if (!authenticated) {
    return <Navigate to={ROUTES.signup} replace={true} />;
  }

  if (!roles.includes(status)) {
    return <Navigate to={ROUTES.unauthorized} replace={true} />;
  }

  if (!isDoneWithBackground) {
    return <Navigate to={ROUTES.backgroundCheck} replace={true} />;
  }

  return children;
};
